import { MouseEvent, KeyboardEvent, FocusEvent, TextfieldEvent } from '@awayjs/scene';
var AVM1EventHandler = /** @class */ (function () {
    function AVM1EventHandler(propertyName, eventName, stageEvent, allowDisable, isMouse, isButton) {
        this.propertyName = propertyName;
        this.eventName = eventName;
        this.stageEvent = stageEvent;
        this.allowDisable = allowDisable;
        this.isMouse = isMouse;
        this.isButton = isButton;
    }
    return AVM1EventHandler;
}());
export { AVM1EventHandler };
var AVM1EventProps = /** @class */ (function () {
    function AVM1EventProps() {
    }
    return AVM1EventProps;
}());
export { AVM1EventProps };
/**
 * Key codes below 32 aren't interpreted as char codes, but are mapped to specific buttons instead.
 * This array uses the key code as the index and KeyboardEvent.keyCode values matching the
 * specific keys as the value.
 * @type {number[]}
 */
export var AVM1KeyCodeMap = [-1, 37, 39, 36, 35, 45, 46, -1, 8, -1, -1, -1, -1, 13, 38, 40, 33, 34, 9, 27];
export var ClipEventMappings = Object.create(null);
var cem = ClipEventMappings;
var EH = AVM1EventHandler;
cem[262144 /* AVM1ClipEvents.Construct */] = true;
cem[512 /* AVM1ClipEvents.Initialize */] = true;
cem[131072 /* AVM1ClipEvents.KeyPress */] = new EH('onKey', KeyboardEvent.KEYDOWN, true, true, false, false);
cem[1 /* AVM1ClipEvents.Load */] = new EH('onLoad', 'load', false, false, false, false);
cem[4 /* AVM1ClipEvents.Unload */] = new EH('onUnload', 'unload', false, false, false, false),
    cem[256 /* AVM1ClipEvents.Data */] = new EH('onData', 'data', false, false, false, false),
    cem[2 /* AVM1ClipEvents.EnterFrame */] = new EH('onEnterFrame', 'enterFrame', false, false, false, false),
    cem[64 /* AVM1ClipEvents.KeyDown */] = new EH('onKeyDown', KeyboardEvent.KEYDOWN, true, true, false, false);
cem[128 /* AVM1ClipEvents.KeyUp */] = new EH('onKeyUp', KeyboardEvent.KEYUP, true, true, false, false);
cem[8 /* AVM1ClipEvents.MouseMove */] = new EH('onMouseMove', MouseEvent.MOUSE_MOVE, true, true, true, false);
cem[16 /* AVM1ClipEvents.MouseDown */] = new EH('onMouseDown', MouseEvent.MOUSE_DOWN, true, true, true, false);
cem[32 /* AVM1ClipEvents.MouseUp */] = new EH('onMouseUp', MouseEvent.MOUSE_UP, true, true, true, false);
cem[1024 /* AVM1ClipEvents.Press */] = new EH('onPress', MouseEvent.MOUSE_DOWN, false, true, true, true);
cem[2048 /* AVM1ClipEvents.Release */] = new EH('onRelease', MouseEvent.MOUSE_UP, false, true, true, true);
cem[4096 /* AVM1ClipEvents.ReleaseOutside */] = new EH('onReleaseOutside', MouseEvent.MOUSE_UP_OUTSIDE, false, true, true, true);
cem[8192 /* AVM1ClipEvents.RollOver */] = new EH('onRollOver', MouseEvent.MOUSE_OVER, false, true, true, true);
cem[16384 /* AVM1ClipEvents.RollOut */] = new EH('onRollOut', MouseEvent.MOUSE_OUT, false, true, true, true);
cem[32768 /* AVM1ClipEvents.DragOver */] = new EH('onDragOver', MouseEvent.DRAG_OVER, false, true, true, true);
cem[65536 /* AVM1ClipEvents.DragOut */] = new EH('onDragOut', MouseEvent.DRAG_OUT, false, true, true, true);
var setFocusEventMapping = new EH('onSetFocus', FocusEvent.FOCUS_IN, false, true, false, false);
var unFocusEventMapping = new EH('onKillFocus', FocusEvent.FOCUS_OUT, false, true, false, false);
var onChangedEventMapping = new EH('onChanged', TextfieldEvent.CHANGED, false, true, false, false);
export var EventsListForMC = [
    ClipEventMappings[1 /* AVM1ClipEvents.Load */],
    ClipEventMappings[4 /* AVM1ClipEvents.Unload */],
    ClipEventMappings[256 /* AVM1ClipEvents.Data */],
    ClipEventMappings[2 /* AVM1ClipEvents.EnterFrame */],
    ClipEventMappings[64 /* AVM1ClipEvents.KeyDown */],
    ClipEventMappings[128 /* AVM1ClipEvents.KeyUp */],
    ClipEventMappings[8 /* AVM1ClipEvents.MouseMove */],
    ClipEventMappings[16 /* AVM1ClipEvents.MouseDown */],
    ClipEventMappings[32 /* AVM1ClipEvents.MouseUp */],
    ClipEventMappings[1024 /* AVM1ClipEvents.Press */],
    ClipEventMappings[2048 /* AVM1ClipEvents.Release */],
    ClipEventMappings[4096 /* AVM1ClipEvents.ReleaseOutside */],
    ClipEventMappings[8192 /* AVM1ClipEvents.RollOver */],
    ClipEventMappings[16384 /* AVM1ClipEvents.RollOut */],
    ClipEventMappings[32768 /* AVM1ClipEvents.DragOver */],
    ClipEventMappings[65536 /* AVM1ClipEvents.DragOut */],
    ClipEventMappings[131072 /* AVM1ClipEvents.KeyPress */],
    setFocusEventMapping,
    unFocusEventMapping,
    onChangedEventMapping
];
export var EventsListForButton = [
    ClipEventMappings[1 /* AVM1ClipEvents.Load */],
    ClipEventMappings[4 /* AVM1ClipEvents.Unload */],
    ClipEventMappings[256 /* AVM1ClipEvents.Data */],
    ClipEventMappings[2 /* AVM1ClipEvents.EnterFrame */],
    ClipEventMappings[64 /* AVM1ClipEvents.KeyDown */],
    ClipEventMappings[128 /* AVM1ClipEvents.KeyUp */],
    ClipEventMappings[1024 /* AVM1ClipEvents.Press */],
    ClipEventMappings[2048 /* AVM1ClipEvents.Release */],
    ClipEventMappings[4096 /* AVM1ClipEvents.ReleaseOutside */],
    ClipEventMappings[8192 /* AVM1ClipEvents.RollOver */],
    ClipEventMappings[16384 /* AVM1ClipEvents.RollOut */],
    ClipEventMappings[32768 /* AVM1ClipEvents.DragOver */],
    ClipEventMappings[65536 /* AVM1ClipEvents.DragOut */],
    ClipEventMappings[131072 /* AVM1ClipEvents.KeyPress */],
    setFocusEventMapping,
    unFocusEventMapping,
    onChangedEventMapping
];
